<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Notas Fiscais</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblNotasFiscais"
                            :itens="notasFiscais"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="primary"
                                        @click.stop="inserirNotaFiscal()"
                                        v-if="mostrarBtnInserirNotaFiscal"
                                        ><i class="fa fa-plus"></i> Inserir Nota
                                        Fiscal</b-button
                                    >
                                </b-button-group>
                            </template>

                            <template slot="dataEmissao" slot-scope="data">
                                <span v-if="data.dataEmissao">{{ $moment(data.dataEmissao).format('DD/MM/YYYY') }}</span>
                                <span v-else>-</span>
                            </template>

                            <template slot="valorNota" slot-scope="data">
                                <span v-if="data.valorNota">{{ data.valorNota | currency }}</span>
                                <span v-else>-</span>
                            </template>

                            <template slot="acoes" slot-scope="data">
                                <pagamento-nota-fiscal-download
                                    v-if="data.temArquivo"
                                    :pagamentoNotaFiscal="data"
                                    :pagamentosServicos="pagamentosServicos"
                                ></pagamento-nota-fiscal-download>
                                <span class="text-primary">
                                    <i
                                        v-if="mostrarBtnEditarNotaFiscal"
                                        class="fa fa-pencil-square-o fa-lg icon-button ml-1"
                                        title="Editar nota fiscal"
                                        @click.stop="editarNotaFiscal(data.pagamentoNotaFiscalId)"
                                    ></i>
                                </span>
                                <pagamento-nota-fiscal-excluir
                                    :pagamento="pagamento"
                                    :pagamentoNotaFiscal="data"
                                    :pagamentosServicos="pagamentosServicos"
                                    @obterPagamentoAtualizado="obterPagamentoAtualizado()"
                                    class="ml-1"
                                    v-if="mostrarBtnExcluirNotaFiscal"
                                ></pagamento-nota-fiscal-excluir>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <pagamento-nota-fiscal-form
            ref="pagamentoNotaFiscalForm"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
            :notaFiscalAtualizarId="notaFiscalAtualizarId"
            :operacao="notaFiscalOperacao"
            :somenteLeitura="somenteLeituraForm"
        ></pagamento-nota-fiscal-form>
    </div>
</template>

<script>
import PagamentoNotaFiscalForm from './PagamentoNotaFiscalForm'
import PagamentoNotaFiscalDownload from './PagamentoNotaFiscalDownload'
import PagamentoNotaFiscalExcluir from './PagamentoNotaFiscalExcluir'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            notasFiscais: [],
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'numeroNota',
                    label: 'Número da NF',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'dataEmissao',
                    label: 'Data Emissão'
                },
                {
                    key: 'valorNota',
                    label: 'Valor da NF'
                },
                {
                    key: 'prestadorRazaoSocial',
                    label: 'Prestador',
                    sortable: true,
                    filterable: true
                }
            ],
            itensPorPagina: 0,
            notaFiscalAtualizarId: null,
            notaFiscalOperacao: null
        }
    },

    methods: {
        obterNotasFiscais() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterNotasFiscais(this.$route.params.pagamentoId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.notasFiscais = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter as notas fiscais.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        inserirNotaFiscal() {
            this.notaFiscalAtualizarId = null
            this.notaFiscalOperacao = 'INSERIR'
            this.$nextTick(() => {
                this.$refs.pagamentoNotaFiscalForm.mostrarModal = true
            })
        },

        editarNotaFiscal(notaFiscalId) {
            this.notaFiscalAtualizarId = notaFiscalId
            this.notaFiscalOperacao = 'ATUALIZAR'
            this.$nextTick(() => {
                this.$refs.pagamentoNotaFiscalForm.mostrarModal = true
            })
        },

        obterPagamentoAtualizado() {
            this.obterNotasFiscais()
            this.$emit('obterPagamentoAtualizado')
        }
    },

    computed: {
        somenteLeituraForm() {
            return this.notaFiscalOperacao === 'ATUALIZAR' && !this.$temAcesso('SGTEC-UFI-PAG-03')
        },

        permiteAcaoFornecedor() {
            return this.pagamento != null
                && (this.pagamento.status == pagamentoStatus.CRIADO
                    || this.pagamento.status == pagamentoStatus.REPROVADO)
                && this.$route.name == 'Sgtec_Fornecedor_Pagamentos_Detalhar'
        },

        mostrarBtnInserirNotaFiscal() {
            return this.$temAcesso('SGTEC-FORN-PAG-05') && this.permiteAcaoFornecedor
        },

        mostrarBtnExcluirNotaFiscal() {
            return this.$temAcesso('SGTEC-FORN-PAG-05') && this.permiteAcaoFornecedor
        },

        mostrarBtnEditarNotaFiscal() {
            return this.$temAcesso('SGTEC-UFI-PAG-03')
        }
    },

    created() {
        this.obterNotasFiscais()
    },

    components: {
        PagamentoNotaFiscalForm,
        PagamentoNotaFiscalDownload,
        PagamentoNotaFiscalExcluir
    }
}
</script>
